import type { RouteRecordRaw } from 'vue-router'
import { externalServiceUrls } from '@/utils/external-services'

function Layout() {
  return import('@/layouts/index.vue')
}

const routes: RouteRecordRaw = {
  path: '/console/docs',
  component: Layout,
  meta: {
    title: '文档',
    menu: false,
    link: externalServiceUrls.docs,
  },
  children: [
    {
      path: '',
      name: 'docs',
      component: () => import('@/views/index.vue'),
      meta: {
        title: '文档',
        menu: false,
        breadcrumb: false,
      },
    },
  ],
}

export default routes
